export namespace CommonEnums {
  export enum module {
    DISUITE = "DISUITE",
    ADMIN = "ADMN",
    STUDIO = "DISTU",
    SCHEDULER = "DISCH",
    MONITOR = "DIMNR",
    LINAGE = "DIMVW",
  }

  export enum change_Ind {
    CREATED = "C",
    NO_CHANGE = "N",
    CHANGED = "Y",
    DELETED = "D",
  }
  export enum pageTitles {
    DASHBOARD = "Home",
    DATAOBJECT = "Data Object",
    DBFUN = "Expression",
    DBSEQ = "Sequence",
    DATACONNECT = "Data Connect",
    DESIGN = "Data Flow",
    DATASTREAM = "Data Stream",
    DATASUBFLOW = "Data Sub Flow",
    PARAMETER = "Project Parameter",
    REPCONN = "Data Point",
    STREAM = "Job Flow",
    UDF = "UDF",
  }

  export enum mode_Ind {
    WRITE = "W",
    READ_ONLY = "R",
    INTERNAL = "I",
  }

  export enum mode {
    EDIT = "EDIT",
    READ = "READ",
    DIFF = "DIFF",
  }

  export enum codes {
    FLDROBJECT = "FLDR",
    LAYER = "LAYR",
    ALIAS_NM = "GROUP",
    HOME_PAGE = "DISTUH",
    REPCONN = "CONN",
    DATAOBJECT = "DOBJ",
    DESIGN = "DXMP",
    STREAM = "DXFLOW",
    DBSEQ = "NSEQ",
    DBFUN = "DBFN",
    UDF = "UDF",
    PARAMETER = "PP",
    UNIT = "DXMPUNIT",

    SOURCE = "DOBJIS",
    TARGET = "DOBJIT",

    EXPRESSION = "EXPR",
    MASKING = "DMSK",
    FILTER = "FLTR",
    MJOINER = "JNR",
    HIVETRANSFORM = "HTRN",

    HDFSCOMMAND = "HCMD",
    DBCOMMAND = "DCMD",
    LOOPSTART = "LPST",
    LOOPEND = "LPED",
    TSTAGE = "TSTG",
    SELECTTRANS = "SLCT",
    DATACLEANSE = "CNSE",
    COMMENT = "CMNT",
    ROLLUP = "RLUP",
    UNION = "UNON",
    DASHBOARDS = "DASHBOARDS",
    MINUS = "MNUS",
    SPLITTER = "SPLT",
    INPUT = "INPUT",
    OUTPUT = "OUTPUT",
    OUTPUT1 = "OUTPUT1",
    TRANSPOSE_CODE = "TNPS",
    CONN_DB = "CONNDB",
    ATTRIBUTE = "ATTR",

    DATACONNECT = "DXMP",
    SOURCECONNECT = "DOBJISC",
    TARGETCONNECT = "DOBJITC",
    DESIGNLETINST = "DESRUI",

    TASK_COMMAND = "TCMD",
    DESIGN_JOB = "DXMPI",
    TASKEMAIL = "EMNF",
    FILETRANSFER = "FTRN",
    LOOKUP = "LKUP",
    REST_JOB = "RSTJ",
    OFFICE365_JOB = "OFC365J",
    COBOL_CONVERTER_JOB = "CBLCJ",
    GOOGLE_PUBLISHER = "GS",
    MONGO_DB = "MG",
    SHAREPOINT_JOB = "SHRPNTJ",
    REPFOLDER = "FLDR",
    TRANSFORM = "TRANSFORM",
    HBASE_DB = "HB",
    JSONC_JOB = "JSONCJ",
    KAFKA_CONSUMER_JOB = "KCJ", //used for streaming
    GOOGLE_SUBSCRIBER_JOB = "GSJ", //used for streaming
    GPS_SUBSCRIBER_JOB = "GSJ",
  }

  export enum defaults {
    VALID_CD = "0",
    ERROR_CD = "0",
    ERROR_MSG = "",
    CLEVEL = 4,
    DEFAULT_PROCESS_ON = "ON", //TBD
    OUT_VALID_CD = "OUT", //TBD
    DEFAULT_FORMAT_TYPE = "", //TBD
    ATTRTYPE_CD = "A",
    ASC_VAL = "A",
    DSC_VAL = "D",
    WINDOW_ATTRTYPE_CD = "W",
    LDAP_VAL = "D",
    STRING_EMPTY = "",
    STRING_VAL_YES = "Y",
    STRING_VAL_NO = "N",
    STRING_FULLY_QUALIFIED_YES = "Yes",
    STRING_FULLY_QUALIFIED_NO = "No",
    STRING_VAL_DATASYN = "D",
    LONG_VAL = -1,
    ZERO = 0,
    SUCCESS_CODE = "0",
    SUCCESS_MSG = "",
    DEFAULT_ORGANIZAION_NAME = "default",
    DEFAULT_ORGANIZAION_ID = -2,
    //Conn defaults
    DEFAULT_VERSION_CODE = "1",
    DEFAULT_VALID_CD_VAL = "0",
    DEFAULT_HADOOP_DIST = "Hortonworks",
    DEFAULT_NUM_VAL = "0",
    DEFAULT_NUM_VAL_INT = 0,
    DEFAULT_SPARK_WEBURL_PORT = 8080,
    DEFAULT_ZOOKEEPER_ZNODE_PARENT = "/hbase",
    DEFAULT_FTP_LITERAL = "FTP",
    SIMPLE_CODE = "Simple",
    EXE_ENGINE_MR = "mr",
    DEFAULT_HDFS_TEMP_LOC = "/tmp",
    DEFAULT_HADOOP_CONF_PATH = "$DI_HOME/app/control/hadoop/conf",
    DEFAULT_BINARY_LITERAL = "BINARY",
    HTTP_PATH_CLISERVICE = "cliservice",
    SFTP_AUTH_MODE_PASSWORD = "password",
    ASCII_CODE = "ASCII",
    QUERY_PRIORITY = "BATCH",
    AWS_CODE = "AWS",
    DEFAULT_PROTOCOL = "http",
    DEFAULT_EMPTY_STRING = "",
    DEFAULT_INT_VAL = -1,
    //RepConn
    CHANGE_IND_NO = "N",
    MODE_FLAG_FOR_READ_WRITE = "W",
    DEFAULT_BOOLEAN_VAL = 0,
    UNLOCK_IND_UNSET = "Y",
    // added properties
    DEFAULT_FILE_TYPE = "D",
    DEFAULT_COLDELIM = ",",
    DEFAULT_ROWDELIM = "\\n",
    DEFAULT_DATETIMEFORMAT = "dd-MMM-yyyy HH:MM:SS.fffffffff",
    NUM_VAL = 0,
    DEFAULT_ESCAPE_CHAR = "04",
    DEFAULT_COLLITEMSDELIM = "\\002",
    DEFAULT_MAPKEYSDELIM = "\\003",
    DEFAULT_ORC_COMPRESSION = "NONE",
    DEFAULT_ORC_STRIPE_SIZE = 268435456,
    DEFAULT_ORC_ROW_INDEX_STRIDE = 10000,
    DEFAULT_ORC_COMPRESS_SIZE = 262144,
    DEFAULT_COMPRESSION = "FALSE",
    DEFAULT_CONVTABLE = "Cp037",
    DEFAULT_SERDECLASS = "com.bizo.hive.serde.csv.CSVSerde",
    DEFAULT_SERDEPROPERTIES = '"separatorChar"="\\u0001","quoteChar"="\'","escapeChar"="\\u0004"',
    PARQUET_MIN_ROW_COUNT_FOR_PAGE_SIZE = 100,
    PARQUET_MAX_ROW_COUNT_FOR_PAGE_SIZE = 10000,
    DEFAULT_ROOTELMNT = "root",
    DEFAULT_DATEFORMAT = "dd-MMM-yyyy",
    DEFAULT_PARQ_DFS_BLOCKSIZE = 262144,
    DEFAULT_PARQ_PAGE_SIZE = 262144,
    DEFAULT_PARQ_DICTIONARY_PAGE_SIZE = 262144,
    DEFAULT_PARQ_BLOCK_SIZE = 262144,
    DEFAULT_PARQ_COMPRESSION = "SNAPPY",
    // DEFAULT_PROCESS_ON = "DI",
    // DEFAULT_FORMAT_TYPE = "CSV",
    // OUT_VALID_CD = "EMPT_COND",
    DEFAULT_SCD_TYPE = "DATE",
    SCD_START_DATE = "TO_DATE('1900/01/01','YYYY/MM/DD')",
    DEFAULT_SCD_END_DATE = "TO_DATE('2099/12/31','YYYY/MM/DD')",

    OPS_FLOW_TYPE_REGULAR = "R",
    BOOLEAN_VAL = "false",
    BOOLEAN_TRUE_VAL = "true",

    IMPORT_SKIP = "S",
    IMPORT_NEW = "C",
    IMPORT_REUSE = "E",
    IMPORT_REPLACE = "R",
    IMPORT_RENAME = "A",

    FOLDER_CODE = "FLDR",
    LAYER_CODE = "LAYR",
    GROUP_CODE = "GROUP",
    CONNECTION_CODE = "CONN",
    DATA_OBJECT_CODE = "DOBJ",
    UDF_CODE = "UDF",
    NATIVE_SEQUENCE_CODE = "NSEQ",
    FUNCTION_CODE = "DBFN",
    DX_FLOW_CODE = "DXFLOW",
    DX_MAP_CODE = "DXMP",
    SCH_CAL_CODE = "CALNDR",
    SCH_EMAIL_CODE = "EMAILACTION",
    SCH_FILE_CODE = "FILEEVENT",
    SCH_TASKGRP_CODE = "TGRP",
    SCH_TASK_CODE = "CMDTASK",
    SCH_FILEWATCHER_CODE = "SCH_FILEWATCHER",
    PROJECT_PARAMETER_CODE = "PP",
    LOG_LEVEL_INFO = "INFO",
    SPARK_UI_PORT = "4040",
    SPARK_CPU_CORES = "*",
    DEFAULT_SSL_VERSION_VAL = "1.2",
    PRIMARY_KEY = 1,
    REST_RESPONSE_FILE_TYPE = "F",
    DATACONNECT_DEFAULT_TYPE = "Table",
    DEFAULT_STREAMING_TEMP_LOC = "/tmpStrmng",
  }

  export enum attrType_Cd {
    ATTRIBUTE = "A",
    DERIVED_ATTRIBUTE = "D",
    ELEMENT = "E",
  }

  export enum editableMode {
    EDITABLE = "Editable",
    READ_ONLY = "ReadOnly",
  }

  export enum obj_Db_PropertyCodes {
    EXTRACT_CODE = "E",
    LOAD_CODE = "L",
  }

  export enum paramTyp {
    PARAM = "P",
    SQLPARAM = "S",
    PROJECT = "PP", //TBD
  }

  export enum tabCode {
    GENERAL = "GEN",
    PROPERTIES = "PROP",
    ATTRIBUTES = "ATTR",
    LATTRIBUTES = "LATTR",
    ATTRIBUTE_MAPPER = "ATTRMAPR",
    OUTPUT_MAPPER = "OUTMAPR",
    INPUT_ATTRIBUTES = "INATTR",
    OUTPUT_ATTRIBUTES = "OUTATTR",
    DERIVED_ATTRIBUTES = "DATTR",
    EXTRACT_PROPERTIES = "EXTP",
    LOADING_PROPERTIES = "LOADP",
    PARAM_PROPERTIES = "RESTP",
    WATER_MARK_PROPERTIES = "WTRMRKP",
    RUNTIME_PROPERTIES = "RPROP",
    SCOPE = "SCOPE",
    TIMERANGE = "TMRNG",
    FILTERS = "FLTR",
    LINKS = "LINKS",
    SPLITTER_CONDITION = "COND",

    DESIGN_PARAM = "DPRM",
    SQL_PARAM = "SPRM",
    LOAD_ORDER = "LOADO",
    OUT_WINDOW_ATTRIBUTES = "OUTWINATTR",
    DASHBOARDS_CONDITION = "DASHBOARDS_CONDITION",
  }

  export enum tgtLoadType {
    SCD = " SCD",
    INSERT = " INS",
    UPDATE = " UPD",
    UPSERT = " UPI",
    DELETE = " DEL",
  }

  export enum unlock_Ind {
    SET = "Y",
    UNSET = "N",
  }

  export enum reusableFlag {
    YES = "Y",
    NO = "N",
  }

  export enum streamingFlg {
    YES = "Y",
    NO = "N",
    DATACONNECT = "D",
  }

  export enum stgDb_Flag {
    YES = "Y",
    NO = "N",
  }

  export enum notNullFlag {
    SET = 1,
    UNSET = 0,
  }

  export enum flag {
    YES = "Y",
    NO = "N",
    yes = "y",
    no = "n",
  }

  export enum importOption {
    SKIP = "S",
    NEW = "C",
    REUSE = "E",
    REPLACE = "R",
    RENAME = "A",
  }

  export enum objectName {
    REPCONN = "Data Point",
    DATAOBJECT = "Data Object",
    DESIGN = "Data Flow",
    STREAM = "Job Flow",
    DBFUN = "Expression",
    DBSEQ = "Sequence",
    UDF = "UDF",
    PARAMETER = "Parameter",
    DATACONNECT = "DataConnect",
    DATASTREAM = "DataStream",
    DATASUBFLOW = "DataSubFlow",
  }

  export enum transposetype {
    COLLAPSE = "COLLAPSE",
    COLUMNSTOROWS = "COLUMNSTOROWS",
  }
}
